import styled from 'styled-components';

import Container from 'components/styled/Container';

export default styled(Container)`
  display: grid;
  grid-gap: 15px 0;
`;
